"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormField = _interopRequireDefault(require("./FormField/FormField"));

var _FormFieldDropTarget = _interopRequireDefault(require("./FormFieldDropTarget"));

var FormFieldList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FormFieldList, _PureComponent);

  function FormFieldList() {
    (0, _classCallCheck2.default)(this, FormFieldList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldList).apply(this, arguments));
  }

  (0, _createClass2.default)(FormFieldList, [{
    key: "renderDropTarget",
    value: function renderDropTarget(props) {
      return _react.default.createElement(_FormFieldDropTarget.default, props);
    }
  }, {
    key: "renderFormField",
    value: function renderFormField(props) {
      return _react.default.createElement(_FormField.default, props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          selectedFields = _this$props.selectedFields,
          moveFormField = _this$props.moveFormField,
          removeFormField = _this$props.removeFormField,
          editFormField = _this$props.editFormField;
      var fieldsLength = selectedFields.length;
      return _react.default.createElement("div", null, selectedFields.map(function (field, index) {
        return [_this.renderDropTarget({
          key: index,
          index: index,
          moveFormField: moveFormField
        }), _this.renderFormField((0, _extends2.default)({}, field, {
          key: field.name,
          removeFormField: removeFormField,
          editFormField: editFormField
        }))];
      }), this.renderDropTarget({
        key: fieldsLength,
        index: fieldsLength,
        moveFormField: moveFormField
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        selectedFields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
          name: _react.PropTypes.string.isRequired,
          label: _react.PropTypes.string.isRequired,
          displayOrder: _react.PropTypes.number.isRequired,
          type: _react.PropTypes.string.isRequired,
          fieldType: _react.PropTypes.string.isRequired,
          options: _react.PropTypes.array.isRequired
        })).isRequired,
        selectedLocale: _react.PropTypes.string.isRequired,
        removeFormField: _react.PropTypes.func.isRequired,
        moveFormField: _react.PropTypes.func.isRequired,
        editFormField: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return FormFieldList;
}(_react.PureComponent);

exports.default = FormFieldList;
module.exports = exports.default;